import { useRequestStatusUtils } from '@axo/shared/data-access/hooks';
import { ace_index, loan_request } from '@axo/shared/data-access/types';
import { StatusTag } from '../StatusTag';

interface Props {
  app: ace_index.LoanApplication;
}

export function RequestStatuses({ app }: Props) {
  const statuses = useRequestStatusUtils();

  if (app.LoanRequests === undefined) {
    return null;
  }

  const all = app.LoanRequests?.map((req) => req.StatusCode).filter(
    (status): status is number => !!status,
  );

  const unique = [...new Set(all)];

  const codes = unique
    .map(statuses.fromCode)
    .filter(
      (code): code is loan_request.LoanRequestStatus => code !== undefined,
    );

  return (
    <>
      {codes.map((code) => (
        <StatusTag key={code} status={code}>
          {code}
        </StatusTag>
      ))}
    </>
  );
}
